module.exports = __webpack_public_path__ + "img/noData.9e7746b9.png";